import { useNavigate } from "react-router-dom";

import {
  ILinkStyleProps,
  ILinkStyles,
  IStyleFunctionOrObject,
  Link
} from "@bps/fluent-ui";

import { JumpTo, useJumpToPath } from "./hooks/useJumpToPath";

interface Props {
  text: string;
  jumpTo: JumpTo;
  underline?: boolean;
  onRenderContent?: (text?: string) => React.ReactElement;
  linkStyles?: IStyleFunctionOrObject<ILinkStyleProps, ILinkStyles>;
}

export const JumpToLink: React.FC<Props> = ({
  text,
  jumpTo,
  underline,
  onRenderContent,
  linkStyles
}) => {
  const navigate = useNavigate();
  const path = useJumpToPath(jumpTo);
  return (
    <Link
      onClick={() => {
        navigate(path, { replace: true });
      }}
      underline={underline}
      styles={linkStyles}
    >
      {onRenderContent ? onRenderContent(text) : text}
    </Link>
  );
};
